import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { blockedMessageStorage } from '../services/auth';
import iconCinema from '../assets/svg/Icon-Cinema.svg';
import iconLightingTech from '../assets/svg/Icon-Lighting Tech.svg';
import iconComposer from '../assets/svg/Icon-Composer.svg';
import iconLyric from '../assets/svg/Icon-Lyric.svg';
import iconMakeup from '../assets/svg/Icon-Makeup.svg';
import iconCostume from '../assets/svg/Icon-Costume.svg';
import iconFilm from '../assets/svg/Icon-Film.svg';
import iconUXUI from '../assets/svg/Icon-UXUI.svg';
import iconProducer from '../assets/svg/Icon-Producer.svg';
import iconSound from '../assets/svg/Icon-Sound.svg';
import iconFields from '../assets/svg/Icon-Fields.svg';
import iconGame from '../assets/svg/Icon-Console.svg';
import Navigation from '../components/Navigation';
import creativeCollage from '../assets/images/landing/cardFilm[1].jpg';
import mediaProduction from '../assets/images/landing/cardFilm[2].jpg';
import contentCreators from '../assets/images/landing/cardFilm[3].jpg';
import filmProduction from '../assets/images/landing/cardFilm[4].jpg';
import cardGaming1 from '../assets/images/landing/cardGaming[1].jpg';
import cardGaming2 from '../assets/images/landing/cardGaming[2].jpg';
import cardGaming3 from '../assets/images/landing/cardGaming[3].jpg';
import cardGaming4 from '../assets/images/landing/cardGaming[4].jpg';
import cardMusic1 from '../assets/images/landing/cardMusic[1].jpg';
import cardMusic2 from '../assets/images/landing/cardMusic[2].jpg';
import cardMusic3 from '../assets/images/landing/cardMusic[3].jpg';
import cardMusic4 from '../assets/images/landing/cardMusic[4].jpg';
import iconLove from '../assets/svg/Icon-Love.svg';
import iconWaveform from '../assets/svg/landing/sound-wave.svg';
import iconPen from '../assets/svg/landing/icon-pen.svg';
import iconPalette from '../assets/svg/Icon-Palette.svg';
import iconCardGaming1 from '../assets/svg/landing/icon-cardGaming[1].svg';
import iconCardGaming2 from '../assets/svg/landing/icon-cardGaming[2].svg';
import iconCardGaming3 from '../assets/svg/landing/icon-cardGaming[3].svg';
import iconCardGaming4 from '../assets/svg/landing/icon-cardGaming[4].svg';
import iconCardMusic1 from '../assets/svg/landing/icon-cardMusic[1].svg';
import iconCardMusic2 from '../assets/svg/landing/icon-cardMusic[2].svg';
import iconCardMusic3 from '../assets/svg/landing/icon-cardMusic[3].svg';
import iconCardMusic4 from '../assets/svg/landing/icon-cardMusic[4].svg';
import brandsImage1 from '../assets/images/landing/MatchHat-for-Brands[1].jpg';
import brandsImage2 from '../assets/images/landing/MatchHat-for-Brands[2].jpg';
import brandsImage3 from '../assets/images/landing/MatchHat-for-Brands[3].jpg';
import mascotThinking from '../assets/images/landing/Mascot-ThinkingV2.jpg';
import clapper from '../assets/images/landing/clapper.jpg';
import popcorn from '../assets/images/landing/popcorn.jpg';
import controllerLeft from '../assets/images/landing/game-controller.jpg';
import controllerRight from '../assets/images/landing/game-controller-2.jpg';
import headphone from '../assets/images/landing/headphone.jpg';
import musicNotes from '../assets/images/landing/music-notes.jpg';
import matchAvatar1 from '../assets/images/landing/avatar-match-1.jpg';
import matchAvatar2 from '../assets/images/landing/avatar-match-2.jpg';
import matchAvatar3 from '../assets/images/landing/avatar-match-3.jpg';
import matchAvatar4 from '../assets/images/landing/avatar-match-4.jpg';
import matchProject1 from '../assets/images/landing/match-project-1.jpg';
import matchProject2 from '../assets/images/landing/match-project-2.jpg';
import matchProject3 from '../assets/images/landing/match-project-3.jpg';
import matchProject4 from '../assets/images/landing/match-project-4.jpg';
import MatchesMascot from '../assets/svg/landing/Mascot - Thinking V1.svg';
import MatchesHappy from '../assets/svg/landing/Mascot - Happy - Yellow.svg';
import Logo from '../assets/logo.svg';
import instagramIcon from '../assets/svg/instagram.svg';
import linkedinIcon from '../assets/svg/linkedin.svg';
import facebookIcon from '../assets/svg/facebook.svg';
import { IClientUser } from '../interfaces/user';

// PROJECTS SECTION - DO NOT REMOVE (temporarily disabled)
// import { useBreakpoint } from '../hooks/useBreakpoint';
// import { useLandingProjects } from '../hooks/useLandingProjects';
// import LandingProjectCard from '../components/Project/LandingProjectCard';
// import type { EGenreOpts } from '../../types/globalTypes';

const paginationDotsCount = 3;

const heroSlides = [
  {
    id: 0,
    title: 'Film Projects',
    leftIcon: clapper,
    rightIcon: popcorn,
    projectCards: [
      {
        id: 1,
        className: 'card-1',
        imageHeight: '402px',
        imageUrl: creativeCollage,
        tagPosition: 'top',
        tagClass: 'is-orange',
        tagIcon: iconLove,
        tagText: "Cinematographers in Kyoto – let's connect!"
      },
      {
        id: 2,
        className: 'card-2',
        imageHeight: '245.85px',
        imageUrl: mediaProduction,
        tagPosition: 'bottom',
        tagClass: 'is-burple',
        tagIcon: iconWaveform,
        tagText: "Sound engineers for a crime podcast, let's chat"
      },
      {
        id: 3,
        className: 'card-3',
        imageHeight: '18.73125rem',
        imageUrl: contentCreators,
        tagPosition: 'top',
        tagClass: 'is-burple',
        tagIcon: iconPen,
        tagText: 'Scriptwriter needed for a sci-fi thriller'
      },
      {
        id: 4,
        className: 'card-4',
        imageHeight: '20.5rem',
        imageUrl: filmProduction,
        tagPosition: 'bottom',
        tagClass: 'is-orange',
        tagIcon: iconPalette,
        tagText: 'Looking for color gradist for my short'
      }
    ]
  },
  {
    id: 1,
    title: 'Gaming Projects',
    leftIcon: controllerLeft,
    rightIcon: controllerRight,
    projectCards: [
      {
        id: 5,
        className: 'card-1',
        imageHeight: '402px',
        imageUrl: cardGaming1,
        tagPosition: 'top',
        tagClass: 'is-orange',
        tagIcon: iconCardGaming1,
        tagText: 'Build Your Legendary Squad'
      },
      {
        id: 6,
        className: 'card-2',
        imageHeight: '245.85px',
        imageUrl: cardGaming2,
        tagPosition: 'bottom',
        tagClass: 'is-burple',
        tagIcon: iconCardGaming2,
        tagText: 'Level Up Your Creative Game Ideas'
      },
      {
        id: 7,
        className: 'card-3',
        imageHeight: '18.73125rem',
        imageUrl: cardGaming3,
        tagPosition: 'top',
        tagClass: 'is-burple',
        tagIcon: iconCardGaming3,
        tagText: 'Unlock Epic Collaborations'
      },
      {
        id: 8,
        className: 'card-4',
        imageHeight: '20.5rem',
        imageUrl: cardGaming4,
        tagPosition: 'bottom',
        tagClass: 'is-orange',
        tagIcon: iconCardGaming4,
        tagText: 'Power Up with Game Creators'
      }
    ]
  },
  {
    id: 2,
    title: 'Music Projects',
    leftIcon: headphone,
    rightIcon: musicNotes,
    projectCards: [
      {
        id: 9,
        className: 'card-1',
        imageHeight: '402px',
        imageUrl: cardMusic1,
        tagPosition: 'top',
        tagClass: 'is-orange',
        tagIcon: iconCardMusic1,
        tagText: 'Build Your Legendary Crew'
      },
      {
        id: 10,
        className: 'card-2',
        imageHeight: '245.85px',
        imageUrl: cardMusic2,
        tagPosition: 'bottom',
        tagClass: 'is-burple',
        tagIcon: iconCardMusic2,
        tagText: 'Level Up Your Creative Music Ideas'
      },
      {
        id: 11,
        className: 'card-3',
        imageHeight: '18.73125rem',
        imageUrl: cardMusic3,
        tagPosition: 'top',
        tagClass: 'is-burple',
        tagIcon: iconCardMusic3,
        tagText: 'Unlock Epic Collaborations'
      },
      {
        id: 12,
        className: 'card-4',
        imageHeight: '20.5rem',
        imageUrl: cardMusic4,
        tagPosition: 'bottom',
        tagClass: 'is-orange',
        tagIcon: iconCardMusic4,
        tagText: 'Power Up with Music Creators'
      }
    ]
  }
];

const creatorTagsData = [
  { icon: iconFilm, label: 'Film Director', className: 'tag-film-director' },
  { icon: iconProducer, label: 'Producer', className: 'tag-producer' },
  { icon: iconCinema, label: 'Cinematographer', className: 'tag-cinematographer' },
  { icon: iconGame, label: 'Game Developer', className: 'tag-game' },
  { icon: iconComposer, label: 'Composer', className: 'tag-composer' },
  { icon: iconLyric, label: 'Lyricist', className: 'tag-lyricist' },
  { icon: iconMakeup, label: 'Makeup Artist', className: 'tag-makeup' },
  { icon: iconSound, label: 'Sound Engineer', className: 'tag-sound' },
  { icon: iconCostume, label: 'Costume Designer', className: 'tag-costume' },
  { icon: iconLightingTech, label: 'Lighting Technician', className: 'tag-lighting' },
  { icon: iconUXUI, label: 'UX/UI Designer', className: 'tag-uxui' }
];

const matchesData = [
  {
    id: 1,
    name: 'Masae Sinjo',
    role: 'CEO',
    testimonial: 'I  had one of the best collaboration experiences! Loved the film we made.',
    avatar: matchAvatar1,
    projectImage: matchProject1,
    layout: 'header-top'
  },
  {
    id: 2,
    name: 'Felicity Tillaek',
    role: 'Filmmaker',
    testimonial: 'It was a pleasure to work on this film together with Masae!',
    avatar: matchAvatar2,
    projectImage: matchProject2,
    layout: 'header-bottom'
  },
  {
    id: 3,
    name: 'Dieter',
    role: 'Director',
    testimonial: 'Collaborating with Rikey was one of the best things that has happened to me this year',
    avatar: matchAvatar3,
    projectImage: matchProject3,
    layout: 'header-bottom'
  },
  {
    id: 4,
    name: 'Rikey',
    role: 'Producer',
    testimonial: 'I knew from the beginning that it would be a match!',
    avatar: matchAvatar4,
    projectImage: matchProject4,
    layout: 'header-top'
  }
];

// eslint-disable-next-line @typescript-eslint/no-var-requires
const matchhatVideo = require('../assets/videos/landing/MatchHat short animation video.gif');

const LandingPage = (
  props: JSX.IntrinsicAttributes & IClientUser & { children?: React.ReactNode }
) => {
  const [offSet, setOffSet] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);
  const [, setActiveCardIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const cardsRef = useRef<HTMLDivElement>(null);
  const heroRef = useRef<HTMLDivElement>(null);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const AUTOPLAY_INTERVAL = 4000;
  const SWIPE_THRESHOLD = 75;

  // PROJECTS SECTION - DO NOT REMOVE (temporarily disabled)
  // const [activeFilter, setActiveFilter] = useState<EGenreOpts | 'All'>('All');
  // const filterContainerRef = useRef<HTMLDivElement>(null);
  // const breakpoint = useBreakpoint();
  // const isMobile = breakpoint === 'xs' || breakpoint === 'sm';
  // const projectLimit = isMobile ? 1 : 2;
  // const { projects, availableGenres, loading, error } = useLandingProjects(
  //   activeFilter,
  //   projectLimit
  // );
  // const handleFilterChange = (filter: EGenreOpts | 'All') => {
  //   setActiveFilter(filter);
  // };
  // const formatGenreName = (name: string): string => {
  //   return name.replace(/([A-Z])/g, ' $1').trim();
  // };

  useEffect(() => {
    const blockedMessage = blockedMessageStorage.get();
    if (blockedMessage) {
      toast.error(blockedMessage, {
        autoClose: 6000
      });
      blockedMessageStorage.clear();
    }
  }, []);

  useEffect(() => {
    window.onscroll = () => {
      setOffSet(window.pageYOffset);
    };
  }, [offSet]);

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % 3);
    }, AUTOPLAY_INTERVAL);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        setActiveSlide((prev) => (prev - 1 + 3) % 3);
        setIsAutoPlaying(false);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        setActiveSlide((prev) => (prev + 1) % 3);
        setIsAutoPlaying(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // PROJECTS SECTION - DO NOT REMOVE (temporarily disabled)
  // useEffect(() => {
  //   if (isMobile && filterContainerRef.current) {
  //     const container = filterContainerRef.current;
  //     const activeButton = container.querySelector('.filter-button.is-active') as HTMLElement;
  //     if (activeButton) {
  //       const containerWidth = container.offsetWidth;
  //       const buttonLeft = activeButton.offsetLeft;
  //       const buttonWidth = activeButton.offsetWidth;
  //       const scrollPosition = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);
  //       container.scrollTo({
  //         left: scrollPosition,
  //         behavior: 'smooth'
  //       });
  //     }
  //   }
  // }, [activeFilter, isMobile]);

  const handleDotClick = (index: number) => {
    setActiveSlide(index);
    setIsAutoPlaying(false);
  };

  const handleTouchStart = (e: any) => {
    setTouchStart(e.touches[0].clientX);
    setTouchEnd(e.touches[0].clientX);
  };
  const handleTouchMove = (e: any) => {
    setTouchEnd(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > SWIPE_THRESHOLD;
    const isRightSwipe = distance < -SWIPE_THRESHOLD;

    if (isLeftSwipe) {
      setActiveSlide((prev) => (prev + 1) % 3);
      setIsAutoPlaying(false);
    } else if (isRightSwipe) {
      setActiveSlide((prev) => (prev - 1 + 3) % 3);
      setIsAutoPlaying(false);
    }

    setTouchStart(0);
    setTouchEnd(0);
  };

  useEffect(() => {
    const cardsContainer = cardsRef.current;
    if (!cardsContainer) return;

    const handleScroll = () => {
      const scrollLeft = cardsContainer.scrollLeft;
      const cardWidth = cardsContainer.offsetWidth;
      const index = Math.round(scrollLeft / cardWidth);
      setActiveCardIndex(Math.min(index, 3));
    };

    cardsContainer.addEventListener('scroll', handleScroll);
    return () => cardsContainer.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <main className="page-landing">
      <Navigation {...props} />
      <section className="page-landing-container">
        <div
          className="hero"
          ref={heroRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div className="container is-flex-mobile">
            <div className="hero-content-mobile">
              <div className="hero-heading-grid is-flex-mobile has-text-centered" key={activeSlide}>
                <h1 className="title has-text-weight-semibold has-text-centered">
                  Find Collaborators<br className="is-hidden-desktop" /> For Your <br className="is-hidden-mobile" />
                  <span className="gradient-text">{heroSlides[activeSlide].title}</span>
                </h1>
                <p className="subtitle has-text-centered has-text-weight-normal">
                  Start Co-Creating With Creators Who Share Your Vision
                </p>
                <img
                  src={heroSlides[activeSlide].leftIcon}
                  alt={`${heroSlides[activeSlide].title} left icon`}
                  className="hero-icon hero-icon-left"
                  key={`left-${activeSlide}`}
                />
                <img
                  src={heroSlides[activeSlide].rightIcon}
                  alt={`${heroSlides[activeSlide].title} right icon`}
                  className="hero-icon hero-icon-right"
                  key={`right-${activeSlide}`}
                />
              </div>

              <div className="has-text-centered">
                <div className="pagination-dots is-inline-flex is-flex">
                  {Array.from({ length: paginationDotsCount }).map((_, index) => (
                    <button
                      key={index}
                      className={`dot ${activeSlide === index ? 'is-active' : ''}`}
                      onClick={() => handleDotClick(index)}
                      aria-label={`Go to slide ${index + 1}: ${heroSlides[index].title}`}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div className="buttons-container">
              <div className="buttons is-flex">
                <Link to="/sign-up" className="button is-rounded btn-creator has-text-weight-bold has-text-white">
                  I'm a Creator
                </Link>
                <Link to="/brand-signup" className="button is-rounded btn-brand has-text-weight-bold has-text-black">
                  I'm a Brand
                </Link>
              </div>
            </div>

            <div className="project-cards is-flex" ref={cardsRef}>
              {heroSlides[activeSlide].projectCards.map((card, index) => {
                let showOnMobile = false;
                let additionalClass = '';
                if (activeSlide === 0) {
                  showOnMobile = index === 0 || index === 3 || index === 2;
                } else if (activeSlide === 1) {
                  showOnMobile = index === 0 || index === 3 || index === 1;
                } else if (activeSlide === 2) {
                  showOnMobile = index === 1 || index === 3 || index === 2;
                  if (index === 1) {
                    additionalClass = 'position-left-mobile';
                  }
                }

                return (
                  <div
                    key={card.id}
                    className={`project-card ${card.className} ${!showOnMobile ? 'hide-on-mobile' : ''} ${additionalClass} has-text-weight-semibold is-flex`}
                  >
                    {card.tagPosition === 'top' && (
                      <div className={`card-tag has-text-weight-semibold is-inline-flex ${card.tagClass} tag-top`}>
                        <img src={card.tagIcon} alt="Icon" />
                        <span>{card.tagText}</span>
                      </div>
                    )}

                    <div className="card-image">
                      <img src={card.imageUrl} alt={`Project ${card.id}`} />
                    </div>

                    {card.tagPosition === 'bottom' && (
                      <div className={`card-tag has-text-weight-semibold is-inline-flex ${card.tagClass} tag-bottom`}>
                        <img src={card.tagIcon} alt="Icon" />
                        <span>{card.tagText}</span>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="connect-creators has-background-white">
          <div className="container">
            <div className="columns is-vcentered is-flex">
              <div className="column is-5">
                <h2 className="title has-text-weight-semibold">
                  Connect with Creators,<br />
                  Build Together
                </h2>
              </div>
              <div className="column is-7">
                <div>
                  <div className="creator-tags-grid is-flex">
                    {creatorTagsData.map((tag, index) => (
                      <div
                        key={index}
                        className={`creator-tag is-rounded has-text-weight-medium ${tag.className}`}
                      >
                        <img src={tag.icon} alt="" className="tag-icon" />
                        <span>{tag.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  <Link to="/sign-up" className="button is-rounded is-medium has-text-weight-medium show-more-button">
                    <span>Show More</span>
                    <img src={iconFields} alt="" className="show-more-icon" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="creative-steps is-flex">
          <div className="container is-flex">
            <div className="steps-content is-flex">
              <h2 className="title has-text-weight-semibold">
                Simple Steps to Creative Collaboration
              </h2>

              <div className="video-container">
                <img
                  src={matchhatVideo}
                  alt="MatchHat collaboration animation"
                  className="collaboration-video"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="matches-section">
          <div className="container">
            <div className="matches-content is-flex">
              <h2 className="title has-text-weight-semibold has-text-centered">
                Matches on MatchHat
              </h2>

              <div className="matches-cards-wrapper is-flex">
                <div className="matches-row matches-row-1">
                  <div className="cartoon-mascot-purple">
                    <img src={MatchesMascot} alt="MatchHat Mascot" />
                  </div>
                  <div className="matches-row-cards is-flex">
                    {matchesData.slice(0, 2).map((match) => (
                      <div
                        key={match.id}
                        className={`matches-match-card match-card-${match.id} layout-${match.layout}`}
                      >
                        {match.layout === 'header-top' ? (
                          <>
                            <div className="match-content-wrapper is-flex">
                              <div className="match-avatar">
                                <img src={match.avatar} alt={match.name} />
                              </div>
                              <div className="match-text-content is-flex">
                                <div className="match-name-role is-flex">
                                  <span className="match-name has-text-weight-semibold">
                                    {match.name}
                                  </span>
                                  <span className="match-role has-text-weight-normal">
                                    {match.role}
                                  </span>
                                </div>
                                <div className="match-testimonial has-text-weight-normal">
                                  {match.testimonial}
                                </div>
                              </div>
                            </div>
                            <div className="match-image">
                              <img src={match.projectImage} alt={`${match.name}'s collaboration`} />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="match-image">
                              <img src={match.projectImage} alt={`${match.name}'s collaboration`} />
                            </div>
                            <div className="match-content-wrapper is-flex">
                              <div className="match-avatar">
                                <img src={match.avatar} alt={match.name} />
                              </div>
                              <div className="match-text-content is-flex">
                                <div className="match-name-role is-flex">
                                  <span className="match-name has-text-weight-semibold">
                                    {match.name}
                                  </span>
                                  <span className="match-role has-text-weight-normal">
                                    {match.role}
                                  </span>
                                </div>
                                <div className="match-testimonial has-text-weight-normal">
                                  {match.testimonial}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="matches-row matches-row-2 is-flex">
                  <div className="cartoon-popcorn">
                    <img src={popcorn} alt="Popcorn" />
                  </div>
                  <div className="cartoon-mascot-yellow">
                    <img src={MatchesHappy} alt="MatchHat Mascot" />
                  </div>
                  <div className="matches-row-cards is-flex">
                    {matchesData.slice(2, 4).map((match) => (
                      <div
                        key={match.id}
                        className={`matches-match-card match-card-${match.id} layout-${match.layout}`}
                      >
                        {match.layout === 'header-top' ? (
                          <>
                            <div className="match-content-wrapper is-flex">
                              <div className="match-avatar">
                                <img src={match.avatar} alt={match.name} />
                              </div>
                              <div className="match-text-content is-flex">
                                <div className="match-name-role is-flex">
                                  <span className="match-name has-text-weight-semibold">
                                    {match.name}
                                  </span>
                                  <span className="match-role has-text-weight-normal">
                                    {match.role}
                                  </span>
                                </div>
                                <div className="match-testimonial has-text-weight-normal">
                                  {match.testimonial}
                                </div>
                              </div>
                            </div>
                            <div className="match-image">
                              <img src={match.projectImage} alt={`${match.name}'s collaboration`} />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="match-image">
                              <img src={match.projectImage} alt={`${match.name}'s collaboration`} />
                            </div>
                            <div className="match-content-wrapper is-flex">
                              <div className="match-avatar">
                                <img src={match.avatar} alt={match.name} />
                              </div>
                              <div className="match-text-content is-flex">
                                <div className="match-name-role is-flex">
                                  <span className="match-name has-text-weight-semibold">
                                    {match.name}
                                  </span>
                                  <span className="match-role has-text-weight-normal">
                                    {match.role}
                                  </span>
                                </div>
                                <div className="match-testimonial has-text-weight-normal">
                                  {match.testimonial}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="matches-cta is-flex">
                <Link
                  to="/sign-up"
                  className="button is-rounded is-primary has-text-weight-bold find-match-button has-text-white"
                >
                  Find Your Match
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/*
          IMPORTANT: DO NOT DELETE THIS CODE
          "Projects on MatchHat" section is temporarily disabled.
          It will be re-enabled in a future update.
          Please keep this code commented for now.
        */}
        {/* <div className="projects-section"></div>
          <div className="projects-section">
            <div className="container">
              <div className="projects-content is-flex">
                <h2 className="title has-text-weight-semibold has-text-centered">
                  Projects on MatchHat
                </h2>

                <div className="project-filters is-flex" ref={filterContainerRef}>
                  <button
                    className={`filter-button has-text-weight-medium ${activeFilter === 'All' ? 'is-active' : ''}`}
                    onClick={() => handleFilterChange('All')}
                  >
                    All
                  </button>

                  {availableGenres.map((genre) => (
                    <button
                      key={genre.id}
                      className={`filter-button has-text-weight-medium ${activeFilter === genre.name ? 'is-active' : ''}`}
                      onClick={() => handleFilterChange(genre.name)}
                    >
                      {formatGenreName(genre.name)}
                    </button>
                  ))}
                </div>

                <div className="project-cards-grid is-flex">
                  {loading ? (
                    <div className="project-cards-grid is-flex">
                      {[1, 2].map((i) => (
                        <div key={i} className="project-item-card is-flex" style={{ opacity: 0.5 }}>
                          <div className="project-item-header is-flex">
                            <div style={{ height: '20px', background: '#E5E5E5', borderRadius: '4px', width: '100px' }}></div>
                            <div style={{ height: '30px', background: '#E5E5E5', borderRadius: '4px', width: '80%', marginTop: '8px' }}></div>
                          </div>
                          <div style={{ height: '100px', background: '#E5E5E5', borderRadius: '4px', margin: '16px 24px' }}></div>
                        </div>
                      ))}
                    </div>
                  ) : error ? (
                    <div className="has-text-centered" style={{ width: '100%', padding: '2rem' }}>
                      <p>Error loading projects. Please try again later.</p>
                    </div>
                  ) : projects.length === 0 ? (
                    <div className="has-text-centered" style={{ width: '100%', padding: '2rem' }}>
                      <p>No projects available for this category.</p>
                    </div>
                  ) : (
                    projects.map((project) => (
                      <LandingProjectCard key={project.id} project={project} />
                    ))
                  )}
                </div>

                <div className="projects-bar-container is-flex">
                  <div className={`projects-bar ${activeFilter === 'All' ? 'is-active' : ''}`}></div>

                  {availableGenres.map((genre) => (
                    <div
                      key={genre.id}
                      className={`projects-bar ${activeFilter === genre.name ? 'is-active' : ''}`}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="brands-section">
          <div className="container">
            <div className="brands-content is-flex">
              <h2 className="title has-text-weight-semibold has-text-centered">
                MatchHat for Brands
              </h2>

              <div className="brands-cards">
                <div className="brand-card is-flex">
                  <div className="brand-card-image">
                    <img
                      src={brandsImage1}
                      alt="Access Top Creators"
                    />
                  </div>
                  <div className="brand-card-content is-flex">
                    <h3 className="brand-card-title has-text-weight-semibold">Access Top Creators</h3>
                    <p className="brand-card-description has-text-weight-normal">
                      Connect with skilled creatives in film, music, and gaming.
                    </p>
                  </div>
                </div>

                <div className="brand-card is-flex">
                  <div className="brand-card-image">
                    <img
                      src={brandsImage2}
                      alt="Hire for Projects or Full-Time Roles"
                    />
                  </div>
                  <div className="brand-card-content is-flex">
                    <h3 className="brand-card-title has-text-weight-semibold">Hire for Projects or Full-Time Roles</h3>
                    <p className="brand-card-description has-text-weight-normal">
                      Find creators ready for short-term collaborations or full-time positions at your company.
                    </p>
                  </div>
                </div>

                <div className="brand-card is-flex">
                  <div className="brand-card-image">
                    <img
                      src={brandsImage3}
                      alt="Revolutionize Your Marketing"
                    />
                  </div>
                  <div className="brand-card-content is-flex">
                    <h3 className="brand-card-title has-text-weight-semibold">Revolutionize Your Marketing</h3>
                    <p className="brand-card-description has-text-weight-normal">
                      Shift from traditional ads to shareable, short-form stories that captivate audiences.
                    </p>
                  </div>
                </div>
              </div>

              <div className="brands-cta is-flex">
                <Link to="/sign-up?type=brand" className="button is-rounded is-primary has-text-weight-bold brands-signup-button has-text-white is-inline-flex is-hidden-mobile">
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-container">
          <div className="footer-content is-flex">
            <div className="footer-mascot">
              <img
                src={mascotThinking}
                alt="MatchHat Mascot"
                className="mascot-image"
              />
            </div>
            <div className="footer-text-section is-flex">
              <h2 className="footer-heading has-text-weight-semibold">
                Need Help or Have Questions?
              </h2>
              <p className="footer-subtext has-text-weight-normal">
                Our Team Is Here To Assist You. Reach Out Anytime, And We’ll Help You Make The Most Of MatchHat!
              </p>
              <a
                href="mailto:contact@matchhat.com"
                className="button footer-button has-text-weight-bold"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom is-flex">
          <div className="footer-bottom-content is-flex">
            <div className="footer-left-section is-flex">
              <img
                src={Logo}
                alt="MatchHat Logo"
                className="footer-logo"
              />
              <div className="footer-social-icons is-flex">
                <a href="https://instagram.com/matchhat" target="_blank" rel="noopener noreferrer">
                  <img src={instagramIcon} alt="Instagram" className="social-icon" />
                </a>
                <a href="https://linkedin.com/company/matchhat" target="_blank" rel="noopener noreferrer">
                  <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
                </a>
                <a href="https://web.facebook.com/GoMatchHat" target="_blank" rel="noopener noreferrer">
                  <img src={facebookIcon} alt="Facebook" className="social-icon" />
                </a>
              </div>
            </div>

            <Link
              to="/sign-up"
              className="footer-signup-button is-flex has-text-weight-bold"
            >
              Sign Up
            </Link>
          </div>

          <div className="footer-bottom-links is-flex">
            <a href="/privacy-policy" className="footer-link has-text-weight-normal">Privacy Policy</a>
            <a href="https://docs.google.com/document/d/1UstL8Ky8_LyOyCIrCrWnL1a-OYl5krmcoXtQ33VTC30/edit?usp=sharing" className="footer-link has-text-weight-normal">User Agreement</a>          </div>
        </div>
      </section>
    </main>
  );
};

export default LandingPage;
